module.exports = __webpack_public_path__ + "static/assets/8a3f337313ead4760add8d1e16acf961.svg";